/*
* Simple plugin adding $can method to Vue.
* Require permissions loaded in window.app.permissions and current userId in window.app.userId
*/

const Acl = {
    install(Vue) {
        // "can" directive accept string with single permission or object containing "permission", and "authorId"
        Vue.directive('can', {
            bind(el, binding) {
                let permission;
                if (binding.value instanceof Object) {
                    if (binding.value.authorId == window.app.userId) {
                        return true;
                    }
                    permission = binding.value.permission;
                } else {
                    permission = binding.value;
                }
                if (window.app.permissions.indexOf(permission) == -1) {
                    el.style.display = 'none';
                }
            }
        });

        Vue.directive('has', {
            bind(el, binding) {
                let role
                if (binding.value instanceof Object) {
                    if (binding.value.authorId == window.app.userId) {
                        return true;
                    }
                    role = binding.value.role;
                } else {
                    role = binding.value;
                }
                if (window.app.roles.indexOf(role) == -1) {
                    el.style.display = 'none';
                }
            }
        })

        // If authorID id is equal to current userId permission is always granted
        Vue.config.globalProperties.$can = function (permission, authorId = false) {
            if (window.app.userId == authorId) {
                return true;
            }
            if (window.app.permissions.indexOf(permission) !== -1) {
                return true;
            }
        }


        Vue.config.globalProperties.$has = function (role, authorId = false) {
            if (window.app.userId == authorId) {
                return true;
            }
            if (window.app.roles.indexOf(role) !== -1) {
                return true;
            }
        }
    }
};

module.exports = Acl;